import React, { useEffect, useState } from 'react';
import { Toast, TextArea, Button } from '@coze-arch/coze-design';
// rokid 命中词检测
import { agentPromptTry } from '@rokid/services';

interface TesterProps {
  agentInfo: {
    name: string;
    description: string;
  };
}

export function Tester(props: TesterProps) {
  const { agentInfo } = props;
  const [tipKeyWord, setTipKeyWord] = useState('');
  const [checkTipkeywordPass, changeCheckTipkeywordPass] = useState<
    'pass' | 'unpass' | 'noCheck'
  >('noCheck');

  const checkTipwordPassFunc = a => {
    const { name, description } = agentInfo;
    if (!name || !description) {
      Toast.warning({ content: '请先输入智能体名称和功能介绍' });
      return;
    }
    agentPromptTry({
      question: tipKeyWord,
      agent_name: name,
      agent_desc: description,
    }).then(
      res => {
        changeCheckTipkeywordPass(res.data?.is_match ? 'pass' : 'unpass');
      },
      reject => {
        Toast.error({
          content: reject?.msg || '提示词检测失败,请稍后重新尝试。',
        });
      }
    );
  };

  return (
    <React.Fragment>
      <p
        style={{
          fontSize: '14px',
          textAlign: 'left',
          color: 'var(--semi-color-text-0)',
          fontWeight: 'bold',
          marginTop: '10px',
        }}
      >
        提示词测试
      </p>
      <p style={{ margin: '10px 0' }}>
        <TextArea
          showClear
          placeholder={
            '请输入一段话，然后来测试你的唤醒词，能否命中Agent的因素就取决于左侧填写的智能体名称、类别和功能介绍。'
          }
          onChange={v => {
            setTipKeyWord(v);
          }}
          style={{ background: 'var(--semi-color-white)' }}
        />
      </p>
      <Button
        block
        theme="outline"
        disabled={!tipKeyWord.length}
        onClick={checkTipwordPassFunc}
      >
        立即测试
      </Button>
      {checkTipkeywordPass === 'pass' ? (
        <Button
          type="primary"
          block
          color="green"
          style={{
            backgroundColor: 'rgb(0 178 60 / 20%)',
            color: '#00b23c',
            margin: '10px 0',
          }}
        >
          测试通过
        </Button>
      ) : null}
      {checkTipkeywordPass === 'unpass' ? (
        <Button
          theme="solid"
          type="danger"
          block
          color="red"
          style={{
            background: '#e5324133',
            color: '#e53241',
            margin: '10px 0',
          }}
        >
          未命中
        </Button>
      ) : null}
    </React.Fragment>
  );
}
